export const QueryParams = {
  AUTH_TOKEN: 'authToken',
  DEPOSIT_AMOUNT: 'depositAmount',
  MONTHLY_AMOUNT: 'monthlyAmount',
  IS_MANUAL_DEPOSIT: 'isManualDeposit',
  DEPOSIT_TYPE: 'depositType',
  SELECT_MAX_AMOUNT: 'selectMaxAmount',
  STATUS: 'status',
  TESTING_AMOUNT: 'testingAmount',
  REDIRECT_TO: 'redirectTo',
  DIRECT_PAYMENT_ID: 'directPaymentId',
  PROVIDER_CALLBACK: 'providerCallback',
  APPLICATION_ID: 'applicationId',
  APPLICANT_ID: 'applicantId',
  PAYMENT_ORIGIN: 'paymentOrigin',
  RETRY: 'retry',
  REASON: 'reason',
  FEATURE_FLAGS: 'featureFlags',
} as const;

export const QueryParamValues = {
  DEPOSIT_SUCCESS: 'deposit-success',
  DEPOSIT_FAIL: 'deposit-fail',
  PAY_OVERDUE_SUCCESS: 'pay-overdue-success',
  PAY_OVERDUE_FAIL: 'pay-overdue-fail',
} as const;
